import React from "react";
import Social from "../SocialTwo";

const Slider = () => {
  return (
    <div className="slider-two">
      <div className="shane_tm_hero" id="home" data-style="three">
        <div className="background bg-slider">
          <div
            className="image"
            style={{  backgroundImage: "url(img/slider/1.webp)", backgroundSize: "80%" }}
          ></div>
        </div>
        {/* End .background */}

        <div className="container">
          <div className="content">
            <div className="name_wrap">
              <h3>
                <span>Conviertete <br /> en Partner de</span> <br />SignusCRM<span className="overlay_effect"></span>
              </h3>
            </div>
            {/* End title */}

            <div className="job_wrap">
              <span className="job" style={{ fontSize: "30px" }}>
                Y GANA DESDE <label class="amber" style={{ fontSize: "35px", fontWeight: "bold" }}>$500</label> <br />POR IMPLEMENTACIÓN.
                <span className="overlay_effect"></span>
              </span>
            </div>
            {/* End designation */}

            <div className="job_wrap sociallo" style={{ position: "absolute", bottom: "-130px", marginTop: "50px" }}>
              <span className="job">
                <Social />
                <span className="overlay_effect"></span>
              </span>
            </div>
          </div>
          {/* End content */}

          <div className="shane_tm_down loaded">
            <div className="line_wrapper">
              <div className="line"></div>
            </div>
          </div>
        </div>
        {/* End .container */}
      </div>
    </div>
  );
};

export default Slider;
